
import { Check, X } from "lucide-react";

export const ComparisonSection = () => {
  const comparisonData = [
    {
      feature: "24/7 Security Monitoring",
      traditional: false,
      edgefi: true,
      note: "Sleep soundly knowing your systems are constantly watched for threats, rather than discovering breaches weeks or months after they happen."
    },
    {
      feature: "Proactive Threat Hunting",
      traditional: false,
      edgefi: true,
      note: "Stay ahead of attackers with experts actively searching for hidden threats in your environment before they can cause damage."
    },
    {
      feature: "Predictable Security Budget",
      traditional: false,
      edgefi: true,
      note: "Plan your finances with confidence using a fixed monthly fee instead of unpredictable emergency response costs after incidents."
    },
    {
      feature: "Security Roadmap Aligned to Your Business",
      traditional: false,
      edgefi: true,
      note: "Your security evolves alongside your business goals with strategic planning, not just tactical fixes after problems arise."
    },
    {
      feature: "Multi-Layered Protection",
      traditional: false,
      edgefi: true,
      note: "Your business gains defense-in-depth protection that addresses multiple threat vectors, not just the basics that leave gaps."
    },
    {
      feature: "Security Posture Visibility",
      traditional: false,
      edgefi: true,
      note: "You receive clear reports showing your security status and improvements over time, eliminating the uncertainty of where you stand."
    },
  ];

  return (
    <section className="py-16 bg-edgefi-white" id="comparison">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-edgefi-purple/10 text-edgefi-purple rounded-full text-sm font-medium mb-4">The Difference</span>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Why Your Business Deserves Better Security
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            See how your security experience could transform compared to traditional approaches.
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto overflow-hidden rounded-xl border border-gray-200 shadow-sm">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th scope="col" className="py-6 px-6 text-left text-sm font-semibold text-gray-900 w-1/2">
                  What You Need
                </th>
                <th scope="col" className="py-6 px-3 text-center text-sm font-semibold text-gray-600">
                  Traditional Security
                </th>
                <th scope="col" className="py-6 px-3 text-center text-sm font-semibold text-edgefi-purple">
                  Your Security with edgefi
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {comparisonData.map((item, index) => (
                <tr key={index} className="hover:bg-gray-50 transition-colors duration-150">
                  <td className="py-4 px-6 text-sm font-medium text-gray-900">
                    {item.feature}
                    <p className="text-xs text-gray-500 mt-1">{item.note}</p>
                  </td>
                  <td className="py-4 px-3 text-center">
                    {item.traditional ? (
                      <Check className="h-5 w-5 text-green-500 mx-auto" />
                    ) : (
                      <X className="h-5 w-5 text-red-500 mx-auto" />
                    )}
                  </td>
                  <td className="py-4 px-3 text-center">
                    {item.edgefi ? (
                      <div className="bg-edgefi-purple/10 rounded-full p-1 inline-flex">
                        <Check className="h-5 w-5 text-edgefi-purple mx-auto" />
                      </div>
                    ) : (
                      <X className="h-5 w-5 text-red-500 mx-auto" />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};
